<div class="app-content sidebar-scroll post-page-background" style="margin-top: 2.5rem;">
  <div class="container no-print">

    <app-profile-banner [profileEditCurrentOrganizationUpdate]="profileBannerCurrentOrganization"></app-profile-banner>

    <div class="row  col-sm-9 profile-lr-pading" >
      <app-personal-profile-edit ></app-personal-profile-edit>
    </div>

    
    <div class="row col-sm-3" style="width: 28%;">
      <app-common-widget [page]="'PROFILE_PAGE'" [inputData]="'PROFILE'"></app-common-widget>
    </div>
  </div>
</div>
